import {Component, EventEmitter, OnInit} from '@angular/core';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {__usernameOrEmail} from '../../../directives/validators/sts-conditional-email-validator.directive';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsTfaRegServiceService} from '../../../services/sts-tfa-reg-service.service';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';
import * as ph from 'libphonenumber-js';

@Component({
  selector: 'app-account-reg-validate-email',
  templateUrl: './account-reg-validate-email.component.html',
  styleUrls: ['./account-reg-validate-email.component.scss']
})
export class AccountRegValidateEmailComponent implements OnInit {
  public model: StsA360RegStep2UsernamePostModel = new StsA360RegStep2UsernamePostModel();
  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frm: FormGroup;
  public frm2: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public emailIsValid = true;
  public wantsToChangeEmail = false;
  public invalidCode = false;
  public tfaReference: string;
  public counter: number;
  public isRunOfAttempt: boolean;
  private lastUnverifiedTfaEmail: string;
  message: StsA360NotificationTokenModel;
  isEmail:boolean=true;
  isEmailReadOnly: boolean = false;
  sentEmailMessage: string;
  sentPhoneTextMessage: string;
  formSubmitSuccess = false;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private cmsService: StsCmsService,
              private router: Router) {

    this.route.params.subscribe(params => {
      if (params['id']){
        this.model = new StsA360RegStep2UsernamePostModel();
        this.model.id = params['id'];
      }
    });
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;
      this.isEmailReadOnly = this.tenantInfo.isEmailReadOnly;

      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          let isSelfRegFlow = portalStatus.isSelfRegFlow;
          if (!isSelfRegFlow) {
            console.log('User attempting to execute \'set username\' without permission! Redirecting to login.');
            this.router.navigateByUrl('/account/signin');
            return;
          }
          this.tfaReference = portalStatus.tfaReference;
          this.lastUnverifiedTfaEmail = portalStatus.lastUnverifiedTfaEmail;
        });

    });

    this.frm2 = this.fb.group({
      code: new FormControl('',
        {
          validators: [ Validators.required] ,
          updateOn: 'blur'
        })
    }, { updateOn: 'submit' });

    this.frm = this.fb.group({
      email: new FormControl('',
        {
          validators: [
            (c: FormControl) => {
              if (!c.value) {
                return {
                  emailRequired: {
                    valid: false
                  }
                };
              }
              if (this.isEmail) {
                let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
                re = re.replace(/(^\\A)|(\\Z$)/g, '');
                this.emailIsValid = (new RegExp(re)).test(c.value);
                return (new RegExp(re)).test(c.value) ? null : {
                  validateEmail: {
                    valid: false
                  }
                };
              }
              else{
                try {
                  var phone = ph.parsePhoneNumberWithError(c.value, 'US')
                  return null;
                }
                catch (ex)
                {
                  console.log(ex.message);
                  return {
                    validateEmail: {
                      valid: false
                    }
                  }
                }
              }
            },
            __usernameOrEmail('email', () => this.getMode())] ,
          updateOn: 'blur'
        })
    }, { updateOn: 'submit' });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
    this.isEmail = this.message.PreferredChannel != "phone";
    this.prepareConfirmationMessage(this.isEmail? this.message.PersonalEmail : this.message.Phone);

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {
    this.frm2.controls['code'].updateValueAndValidity();
    this.frm.controls['email'].updateValueAndValidity();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.errors = [];
    this.triggerValidation('');
    if (this.wantsToChangeEmail) {
      this.wantsToChangeEmail = !this.wantsToChangeEmail;
    } else { this.router.navigateByUrl('/'); }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getMode(): string {
    return this.wantsToChangeEmail ? 'email' : 'code';
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  changeMode(): void {
    this.wantsToChangeEmail = !this.wantsToChangeEmail;
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  isInvalidCode(): boolean {
    return this.frm2.controls['code'].invalid &&
      (this.frm2.controls['code'].dirty || this.frm2.controls['code'].touched);
  }

  consolidateUsername(): void {
    if (!this.frm.controls['email'].value && this.lastUnverifiedTfaEmail) {
      if(this.isEmail)
        this.frm.controls['email'].setValue(this.lastUnverifiedTfaEmail);
      else
        this.frm.controls['email'].setValue(this.message.Phone);
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  resendEmail(): void {
    this.errors = [];
    this.consolidateUsername();
    this.triggerValidation('');

    this.tfa.authMethods(this.tenantInfo.tfaPreferredMode, '').subscribe(deliveryChannels => {
      console.log(deliveryChannels);
      if (!deliveryChannels || (deliveryChannels && deliveryChannels.length === 0)) {
        // if there is no setting for the user then show a error message
        let e = new StsNotification();
        e.code = 'sts-auth-no-setting';
        e.level = StsNotificationType.Error;
        this.cmsService.getText(e.code).subscribe(res => {
          e.description = res ? res : 'There is no authentication setting for this user.';
          this.errors = [e];
        });

      } else if (deliveryChannels && deliveryChannels.length > 0) {
        if (deliveryChannels[0].runOutOfAttempts) {
          this.isRunOfAttempt = true;
          this.cmsService.getText('sts-resend-outof-attempt').subscribe(result => {
            let description = deliveryChannels[0].tfaDeliveryChannel.toLowerCase() == 'email'
              ? 'You are running out of attempts to resend email to get a new code, please re-try after {{counter}} second(s).'
              : 'You are running out of attempts to resend SMS to get a new code, please re-try after {{counter}} second(s).';
              let e = new StsNotification();
              e.code = 'Dummy';
             //Dummy should never have label in CMS.We want to directly read from CMS but not from app-sts-cms-txt because Interpolation of counter doesnot work.
              e.level = StsNotificationType.Error;
            // show error message
            let counterForNextAvailableAttemptInSeconds = deliveryChannels[0].nextAvailableAttemptInSeconds ? deliveryChannels[0].nextAvailableAttemptInSeconds : 60;
            e.description =  (result || description).replace("{{counter}}", counterForNextAvailableAttemptInSeconds.toString());
            this.errors = [e];
          });
        }
        else {
          this.tfa.sendValidationEmail(this.message.PreferredChannel, this.frm.controls['email'].value).subscribe(
            a => {
              if (a.success) {
                if (a['referenceNumber']) {
                  this.tfaReference = a['referenceNumber'];
                }
                let e = new StsNotification();
                e.code = 'sts-verification-resent';
                e.level = StsNotificationType.Success;
                e.description = 'A new email was sent.';
                if(!this.isEmail)
                {
                  e.description = 'A new SMS was sent.';
                  e.code = 'sts-verification-resent-phone';
                }
                this.errors = [e];
              } else {
                let e = new StsNotification();
                e.code = a.stsCode || 'sts-verification-resent-failed';
                e.level = StsNotificationType.Error;
                e.description = 'A new email was not sent.';
                if(!this.isEmail)
                {
                  e.code = a.stsCode || 'sts-verification-resent-failed-phone';
                  e.description = 'A new SMS was not sent.';
                }
                this.errors = [e];
              }
            });
        }
      }


    });


  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmit(): void {
    // console.log(this.getMode(), this.emailIsValid);
    this.submitter.emit(false);
    this.consolidateUsername();
    this.triggerValidation('');
    if (this.frm.valid) {
      var phoneOrEmail = this.frm.controls['email'].value;
      try {
        if (!this.isEmail)
          phoneOrEmail = ph.parsePhoneNumberWithError(phoneOrEmail, 'US').number;
      }
      catch(ex)
      {
        console.log(ex);
      }
      this.submitter.emit(true);
      this.errors = [];

      this.prepareConfirmationMessage(phoneOrEmail);
      //Will need to register as the email might have changed
      if(this.isEmail && phoneOrEmail != this.message.PersonalEmail && this.model){
        let n = new StsA360RegStep2UsernamePostModel();
        n.id = this.model.id;
        n.email = phoneOrEmail;
        n.username = this.message.UserName;

        this.message.PersonalEmail = n.email;
        this.regService.changeMessage(this.message);
        this.regService.postStep2Answers(n).subscribe(rs => {
          this.submitter.emit(false);
          if (rs.success) {
            this.tfa.sendValidationEmail(this.message.PreferredChannel, phoneOrEmail).subscribe(a => {
              if (a.success) {
                this.submitter.emit(false);
                let e = new StsNotification();
                e.code = 'sts-verification-resent';
                e.level = StsNotificationType.Success;
                e.description = 'A new email was sent.';
                if(!this.isEmail)
                {
                  e.description = 'A new SMS was sent.';
                  e.code = 'sts-verification-resent-phone';
                }
                this.errors = [e];
                this.changeMode();
              } else {
                this.submitter.emit(false);
                let e = new StsNotification();
                e.code =  a.stsCode || 'sts-correct-email-errors';
                e.level = StsNotificationType.Error;
                e.description = 'Submitted data has invalid format';
                this.errors = [e];
              }
            });
          }
        });
      }
      else{
        this.tfa.sendValidationEmail(this.message.PreferredChannel, phoneOrEmail).subscribe(a => {
          if (a.success) {
            this.submitter.emit(false);
            let e = new StsNotification();
            e.code = 'sts-verification-resent';
            e.level = StsNotificationType.Success;
            e.description = 'A new email was sent.';
            if(!this.isEmail)
            {
              e.description = 'A new SMS was sent.';
              e.code = 'sts-verification-resent-phone';
            }
            this.errors = [e];
            this.changeMode();
          } else {
            this.submitter.emit(false);
            let e = new StsNotification();
            e.code =  a.stsCode || 'sts-correct-email-errors';
            e.level = StsNotificationType.Error;
            e.description = 'Submitted data has invalid format';
            this.errors = [e];
          }
        });
      }
    } else {
      this.submitter.emit(false);
      let e = new StsNotification();
      e.code = this.isEmail ? 'sts-correct-email-errors' : 'sts-correct-phone-errors';

      e.level = StsNotificationType.Error;
      e.description = this.isEmail ? 'Submitted email has invalid format' : 'Submitted phone has invalid format. The correct format is<br>1234567890<br>123-456-7890<br>(123) 456-7890<br>123 456 7890<br>123.456.7890<br>+91 (123) 456-7890';
      this.errors = [e];
    }
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmitCode(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    this.invalidCode = false;
    if (this.frm2.valid) {
      this.submitter.emit(true);
      this.errors = [];
      this.tfa.validateCode(this.frm2.controls['code'].value).subscribe(a => {
        this.formSubmitSuccess = true;
        this.submitter.emit(false);
        if (a.success) {
          this.router.navigateByUrl( '/account/password/new');
        } else {
          this.formSubmitSuccess = false;
          this.submitter.emit(false);
          let e = new StsNotification();
          e.code = a['sts-code'] || a.stsCode;
          e.level = StsNotificationType.Error;
          this.cmsService.getText(e.code).subscribe(res => {
            e.description = res ? res : 'submitted data contains errors.';
            this.errors = [e];
          });
        }
      });
    } else {
      this.submitter.emit(false);
      let e = new StsNotification();
      e.code = 'sts-incorrect-verification-code-errors';
      e.level = StsNotificationType.Error;
      e.description = 'submitted data contains errors';
      this.errors = [e];
    }
  }

  private prepareConfirmationMessage(address: string) {
    this.tenantService.getTenantSource().subscribe(tenant => {
      let tenantEmailDeliveryTtl = tenant.defaultSecurityPolicy.tfaDeliveryChannels;
      if (tenantEmailDeliveryTtl.length > 0 && tenantEmailDeliveryTtl.filter(x => x.deliveryChannel === "EMAIL").length === 1) {
        this.cmsService.getText('sts-signup-step-3-validate-body-section').subscribe(res => {
          let message = `We have sent an email to {{emailAddress}}. Please enter the verification code sent to you in the provided field below.`;
          let ttl =  tenantEmailDeliveryTtl.filter(x => x.deliveryChannel === "EMAIL")[0].deliveryTtl;
          message = res ? res.replace('XX', ttl) : message;
          this.sentEmailMessage = message.replace('{{emailAddress}}', this.maskEmail(address));
        });
      } else{
        this.cmsService.getText('sts-signup-step-3-validate-body-section-phone').subscribe(res => {
          let message = res ? res : `We have sent a text to {{phoneNumber}}. Please enter the verification code sent to you in the provided field below.`;
          this.sentPhoneTextMessage = message.replace('{{phoneNumber}}', this.maskPhone(address));
        });
      }
    });
  }

  private maskPhone(phone: string): string {
    if (phone == undefined || phone.length == 0) {
      return '';
    }

    return phone.replace(/\d(?!\d{0,3}$)/g, 'x');
  }

  private maskEmail(email: string): string {
    if (email == undefined || email.length == 0)
    {
      return '';
    }

    let atIndex = email.indexOf('@');
    if (atIndex < 2)
    {
      return '';
    }

    let toReplace = email.substring(1, atIndex - 1);
    if (toReplace.length < 1)
    {
      return '';
    }

    let replaceWith = '';
    for (let i = 0; i < toReplace.length; i++)
    {
      replaceWith = replaceWith + 'x';
    }

    return email.replace(toReplace, replaceWith);
  }

}
